import React from 'react';
import {SectionMain, Tabs, Tab} from 'components/core';
import Singletons from 'controllers/Singletons';
import {TasksCtxProvider} from 'components/dataProviders/tasks';
import {ProceduresCtxProvider} from 'components/dataProviders/procedures';
import TasksPanel from './main/panel';
import TasksMain from './main/index';
import {TasksFilesProvider} from 'components/dataProviders/tasks';

export default function ProceduresWrapper()
{
  return <TasksCtxProvider><Tasks></Tasks></TasksCtxProvider>
}


function Tasks()
{
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [panelState, setPanelState] = React.useState({show: false, props: {}});
    const [createDialogOpen, setCreateDialogOpen] = React.useState(false);
    const [loadedTask, setLoadedTask] = React.useState(null);

    const editable = Singletons.currentUser.profiles.indexOf("experts") > -1 || Singletons.currentUser.profiles.indexOf("administrators") > -1;

    const tabFilters = [
      "not_started",
      "in_progress",
      "completed"
    ]
    const tabButtonLabels = [
      "Crear Tarea",
      "Crear Tarea",
      "Crear Tarea",
      // "Crear Tarea"
    ];

    const handleNewButtonClick = () =>
    {
      setCreateDialogOpen(true);
    }

    const handleTabChange = (index) =>
    {
      if(index !== selectedTab)
      {
        setPanelState({show: false, props: {}});
        setSelectedTab(index);
      }
    }

    const handleClosePanel = () =>
    {
        setPanelState({show: false, props: {}});
    }

    const handleShowPanel = (panelProps) =>
    {
      setLoadedTask(panelProps.taskID);
      setPanelState({show: true, props: panelProps});
    }

    const tabs = <Tabs value={selectedTab} onChange={(evt, index) => handleTabChange(index)} textColor="primary" indicatorColor="primary">
        <Tab label="Tareas Pendientes"/>
        <Tab label="Tareas En Curso"/>
        <Tab label="Tareas Completadas"/>
        {/* <Tab label="Programador de Tareas"/> */}
    </Tabs>

    const panels = [
      <TasksPanel {...panelState.props} onClose={() => handleClosePanel()} editable={editable}/>,
      <TasksPanel {...panelState.props} onClose={() => handleClosePanel()} editable={editable}/>,
      <TasksPanel {...panelState.props} onClose={() => handleClosePanel()} editable={editable}/>
    ];

    

    return <> 
      
      <TasksFilesProvider taskID={loadedTask}>
        <ProceduresCtxProvider>
          <SectionMain title="Tareas" buttonLabel={tabButtonLabels[selectedTab]} tabs={tabs} showDetail={panelState.show} onButtonClick={() => handleNewButtonClick()} detail = {panels[selectedTab]} buttonHidden={!editable}>
            <TasksMain mainDialogOpen={createDialogOpen} handleDialogClose={()=>setCreateDialogOpen(false)} collapsed = {panelState.show} handleShowPanel={(props) => handleShowPanel(props)} dataset={tabFilters[selectedTab]}/>
          </SectionMain>
        </ProceduresCtxProvider>
      </TasksFilesProvider>
    </>
}

